import * as watchlistActions from './watchlistsActions';
import * as watchlistItemsActions from './watchlistItemsActions';
import * as thematicWatchlistActions from './thematicWatchlistActions';
import * as initialiseWatchlistsActions from './initialiseWatchlistsActions';
import * as optoWatchlistActions from './optoWatchlistActions';
export const watchlistsActions = {
  ...watchlistActions,
  ...watchlistItemsActions,
  ...thematicWatchlistActions,
  ...initialiseWatchlistsActions,
  ...optoWatchlistActions
};
export * from './apiNames';
export { createWatchlistsStore, defaultWatchlistsStore, WATCHLISTS_STORE_NAME } from './store';
export * from './hooks';
export * from './constants';
export * from './types';
